import React from 'react';
import './FiltersContainer.css';

/**
 * Composant wrapper pour le conteneur de filtres
 * @param {string} title - Titre des filtres (défaut: "FILTRES")
 * @param {ReactNode} children - Contenu des filtres (Selects, DateGroups, etc.)
 * @param {string} className - Classes CSS supplémentaires
 */
const FiltersContainer = ({
  title = 'FILTRES',
  children,
  className = '',
}) => {
  const containerClass = `filters-container ${className}`.trim();

  return (
    <>
      {title && <h2 className="filters-title">{title}</h2>}
      <div className={containerClass}>
        {children}
      </div>
    </>
  );
};

export default FiltersContainer;

